import React from 'react';
import { useShallow } from 'zustand/react/shallow'

// components
import Modal from 'components/Modal/Modal';
import useAuthoringDataStore from 'containers/studies/Study/subcomponents/Authoring/hooks/stores/useAuthoringDataStore.jsx';

const ConfirmDeleteArrayItem = ({
  openModal,
  setOpenModal,
  element,
  parentProps
}) => {
  const {
    translationsData,
    setTranslationsData,
  } = useAuthoringDataStore(
    useShallow(state => ({
      translationsData: state.translationsData,
      setTranslationsData: state.setTranslationsData,
    }))
  )

  const onDelete = () => {
    setOpenModal(false)
    deleteFromTranslations(element.index)
    setTimeout(element.onDropIndexClick(element.index), 100);
  }

  const deleteFromTranslations = (index) => {
    let temp = { ...translationsData }

    let mainKey = `${parentProps.idSchema.$id.replace("root.", "")}.${index}.`
    let objKeys = Object.keys(parentProps.idSchema)
    delete objKeys.$id

    Object.keys(temp).forEach(lang => {
      objKeys.forEach(key => {
        delete temp[lang][mainKey + key]
      })
    })

    setTranslationsData(temp)
  }

  return <Modal
    type="delete"
    title="Are you sure you want to delete?"
    message="NOTE: This action can not be undone"
    open={openModal}
    onCancel={() => setOpenModal(false)}
    onOk={onDelete}
    className="pft-comment-modal"
  />
}

export default ConfirmDeleteArrayItem